import { useIntl } from 'react-intl';

import messages from './messages';
import {
	ButtonWrapper,
	Content,
	FreeButton,
	Grid,
	RatingsTitle,
	Star,
	Testimonial,
	TileSubtitle,
	Wrapper,
} from './styles';

const Ratings = () => {
	const { formatMessage } = useIntl();

	function scrollToSignupForm() {
		const loginSignup = document.getElementById('login-signup');
		const loginOffset = loginSignup ? loginSignup.getBoundingClientRect().top - 80 : 0;
		const top = window.pageYOffset + loginOffset;

		if (loginSignup) {
			window.scroll({
				top,
				left: 0,
				behavior: 'smooth',
			});
		}
	}

	return (
		<Wrapper>
			<Grid>
				<Content>
					<RatingsTitle>{formatMessage(messages.title)}</RatingsTitle>
					<TileSubtitle>
						<Star src="/_n/images/thomas/stars-full.webp" />
						{formatMessage(messages.ratings)}
					</TileSubtitle>
				</Content>
				<Testimonial>{formatMessage(messages.review)}</Testimonial>
				<ButtonWrapper>
					<FreeButton onPress={scrollToSignupForm} backgroundColor="buttonGreen">
						{formatMessage(messages.buttonText)}
					</FreeButton>
				</ButtonWrapper>
			</Grid>
		</Wrapper>
	);
};

export default Ratings;
